function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleAnalytics = function SvgGoogleAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.972 6a5.648 5.648 0 0 0-5.648 5.648v34.704a5.648 5.648 0 1 0 11.297 0V11.649A5.648 5.648 0 0 0 44.972 6Zm-20.62 23.251a5.648 5.648 0 0 1 11.296 0v17.1a5.648 5.648 0 1 1-11.297 0v-17.1Zm-3.676 17.1a5.648 5.648 0 1 1-11.297 0 5.648 5.648 0 0 1 11.297 0Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgGoogleAnalytics;